var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsericon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.98072 10.7921C11.9807 10.7921 13.5847 9.16835 13.5847 7.18815C13.5847 5.20796 11.9807 3.56439 9.98072 3.56439C7.98072 3.56439 6.37676 5.18815 6.37676 7.16835C6.37676 9.14855 7.98072 10.7921 9.98072 10.7921V10.7921ZM9.98072 4.51489C11.4461 4.51489 12.6342 5.70301 12.6342 7.16835C12.6342 8.6337 11.4461 9.82182 9.98072 9.82182C8.51537 9.82182 7.32725 8.6535 7.32725 7.18815C7.32725 5.72281 8.51537 4.51489 9.98072 4.51489V4.51489ZM3.72329 16.4357H16.2777C16.5352 16.4357 16.753 16.2179 16.753 15.9604C16.753 13.4654 14.7134 11.4258 12.2183 11.4258H7.7827C5.28765 11.4258 3.24805 13.4654 3.24805 15.9604C3.24805 16.2179 3.46587 16.4357 3.72329 16.4357V16.4357ZM7.7827 12.3763H12.2183C14.0401 12.3763 15.5253 13.7228 15.7629 15.4852H4.23815C4.47577 13.7228 5.96092 12.3763 7.7827 12.3763Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsericon);
export default __webpack_public_path__ + "static/media/usericon.9ba2269c.svg";
export { ForwardRef as ReactComponent };